import React from "react";
import { Shield, BarChart, Lock } from "lucide-react";

const TransparencySection = () => {
  return (
    <section className="section-spacing bg-gradient-to-b from-white to-[#f5f5f5]">
      <div className="container-custom">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16 fade-in">
            <div className="inline-block px-4 py-2 bg-[#4a9da8]/10 text-[#4a9da8] text-sm font-semibold rounded-full mb-4">
              Unsere Werte
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#0f1419] mb-6">
              Vertrauen durch
              <br />
              <span className="gradient-text">Transparenz & Kontrolle</span>
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="card-hover bg-white border-2 border-[#e8e4dc] p-10 rounded-3xl fade-in">
              <div className="w-16 h-16 bg-gradient-to-br from-[#2c4a52] to-[#4a9da8] rounded-2xl flex items-center justify-center mb-6">
                <Shield className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-[#0f1419] mb-4">
                Vollständige Transparenz
              </h3>
              <p className="text-lg text-[#3a3a3a] leading-relaxed">
                Ziele, Maßnahmen und Ergebnisse sind jederzeit nachvollziehbar. Sie behalten die volle Kontrolle über Ihre digitale Präsenz.
              </p>
            </div>

            <div className="card-hover bg-white border-2 border-[#e8e4dc] p-10 rounded-3xl fade-in" style={{ animationDelay: '0.2s' }}>
              <div className="w-16 h-16 bg-gradient-to-br from-[#3d5d66] to-[#4a9da8] rounded-2xl flex items-center justify-center mb-6">
                <BarChart className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-[#0f1419] mb-4">
                Datenbasierte Entscheidungen
              </h3>
              <p className="text-lg text-[#3a3a3a] leading-relaxed">
                Entscheidungen basieren auf Daten – nicht auf Annahmen. Jede Maßnahme wird kontinuierlich ausgewertet und optimiert.
              </p>
            </div>
          </div>

          {/* Additional trust badges */}
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            <div className="bg-white border border-[#e8e4dc] p-6 rounded-2xl text-center fade-in" style={{ animationDelay: '0.4s' }}>
              <div className="w-12 h-12 bg-[#4a9da8]/10 rounded-xl flex items-center justify-center mx-auto mb-4">
                <Lock className="w-6 h-6 text-[#4a9da8]" />
              </div>
              <h4 className="font-semibold text-[#0f1419] mb-2">Datenschutz</h4>
              <p className="text-sm text-[#3a3a3a]/70">DSGVO-konform</p>
            </div>

            <div className="bg-white border border-[#e8e4dc] p-6 rounded-2xl text-center fade-in" style={{ animationDelay: '0.5s' }}>
              <div className="w-12 h-12 bg-[#4a9da8]/10 rounded-xl flex items-center justify-center mx-auto mb-4">
                <Shield className="w-6 h-6 text-[#4a9da8]" />
              </div>
              <h4 className="font-semibold text-[#0f1419] mb-2">Vertragssicherheit</h4>
              <p className="text-sm text-[#3a3a3a]/70">Monatlich kündbar</p>
            </div>

            <div className="bg-white border border-[#e8e4dc] p-6 rounded-2xl text-center fade-in" style={{ animationDelay: '0.6s' }}>
              <div className="w-12 h-12 bg-[#4a9da8]/10 rounded-xl flex items-center justify-center mx-auto mb-4">
                <BarChart className="w-6 h-6 text-[#4a9da8]" />
              </div>
              <h4 className="font-semibold text-[#0f1419] mb-2">Live-Reporting</h4>
              <p className="text-sm text-[#3a3a3a]/70">Jederzeit einsehbar</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TransparencySection;
